import React from "react";
import type {ReactNode} from "react";
import {useAuth} from "../auth";
import {navigate, useRoute} from "../hooks";
import {Logo} from "./Logo";

const NAV_ITEMS = [
    {path: "#/payments", label: "Payments", icon: "P"},
    {path: "#/balance", label: "Balance", icon: "B"},
    {path: "#/history", label: "History", icon: "H"},
] as const;

interface AppLayoutProps {
    children: ReactNode;
}

export function AppLayout({children}: AppLayoutProps): JSX.Element {
    const {user, logout} = useAuth();
    const route = useRoute();

    return (
        <div className="app-layout trader-layout">
            <aside className="sidebar">
                <div className="sidebar-brand" onClick={() => navigate("#/payments")}>
                    <Logo size={24}/>
                    <span>Payments</span>
                </div>
                <nav className="sidebar-nav">
                    {NAV_ITEMS.map((item) => (
                        <a
                            key={item.path}
                            href={item.path}
                            className={`nav-item ${route.startsWith(item.path) ? "active" : ""}`}
                        >
                            <span className="nav-icon">{item.icon}</span>
                            {item.label}
                        </a>
                    ))}
                </nav>
                <div className="sidebar-footer">
                    <a
                        className={`user-info user-info-link ${route.startsWith("#/settings") ? "active" : ""}`}
                        href="#/settings"
                        aria-current={route.startsWith("#/settings") ? "page" : undefined}
                    >
                        <div className="user-avatar">
                            {(user?.login || "U")[0].toUpperCase()}
                        </div>
                        <div className="user-meta">
                            <span className="user-name">{user?.login || "unknown"}</span>
                            <span className="user-role">{user?.roles?.join(", ") || "unknown"}</span>
                            <span className="user-settings">Настройки</span>
                        </div>
                    </a>
                    <button className="btn btn-ghost btn-sm" onClick={logout}>
                        Logout
                    </button>
                </div>
            </aside>
            <main className="main-content">{children}</main>
        </div>
    );
}
